import { Box, Typography, LinearProgress } from '@mui/material';
import React from 'react';
import BaseModelTextImg from '../../../assets/images/base-model-text.png';

interface StakeListProps {
  title: string;
  data: StakeItem[];
}

interface StakeItem {
  name: string;
  imageUrl: string;
  percentage: number;
}

const StakeList: React.FC<StakeListProps> = (props) => {
  return (
    <Box flex={1}>
      <Typography marginBottom={2} marginTop={1}>
        {props.title}
      </Typography>
      <Box maxHeight={100} sx={{ overflowY: 'scroll' }}>
        {props.data.map((item: StakeItem) => {
          if (item.percentage <= 0) return null;
          return (
            <Box display="flex" alignItems="center" gap={2} marginBottom={1}>
              <Box width={140} display="flex" gap={1} alignItems="center">
                <img
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 50,
                    objectFit: 'cover',
                  }}
                  src={item.imageUrl ?? BaseModelTextImg}
                  alt={item.name}
                />
                <Typography fontSize={14}>{item.name}</Typography>
              </Box>
              <Box flex={2}>
                <LinearProgress
                  sx={{ height: 10, borderRadius: 5 }}
                  variant="determinate"
                  value={item.percentage}
                />
              </Box>
              <Box maxWidth={100}>{item.percentage}%</Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default StakeList;
